import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "slick-carousel";

function Testimonials({ content }) {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const activeTestimonial = content.items[activeSlide];

  useEffect(() => {
    const slider = $(sliderRef.current);

    slider.on("beforeChange", (_event, _slick, _currentSlide, nextSlide) => {
      setActiveSlide(nextSlide);
    });

    slider.slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: false,
      fade: false,
      infinite: true,
      pauseOnHover: true,
      rtl: false,
      speed: 750,
      cssEase: "cubic-bezier(0.65, 0, 0.35, 1)",
      slidesToScroll: 1,
      slidesToShow: 1,
    });

    return () => {
      slider.off("beforeChange");
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    };
  }, []);

  return (
    <section className="testimonials-section">
      <div className="container">
        <p className="eybrow" data-wow="fade-up">
          <img
            className="star-icon"
            src="/assets/images/star.png"
            alt=""
            aria-hidden="true"
          />
          {content.eyebrow}
        </p>
        <h2 className="heading text-center" data-wow="fade-up">{content.title}</h2>
      </div>

      <div className="testimonial-stage">
        <div className="row g-0 align-items-stretch">
          <div className="col-lg-6 testimonial-image-column" data-wow="fade-right">
            <div className="testimonials-slider" ref={sliderRef}>
              {content.items.map((testimonial, index) => (
                <div className="testimonial-image-slide" key={testimonial.name}>
                  <div className="testimonial-image-wrap">
                    <img src={testimonial.image} alt={testimonial.imageAlt} />
                    <span className="testimonial-count">
                      {String(index + 1).padStart(2, "0")} |{" "}
                      {String(content.items.length).padStart(2, "0")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6 testimonial-copy-column" data-wow="fade-left">
            <div className="testimonial-content" key={activeTestimonial.name}>
              <p className="title">{activeTestimonial.heading}</p>
              <blockquote>“{activeTestimonial.quote}”</blockquote>
              <div className="testimonial-author">
                <div>
                  <p>{activeTestimonial.name}</p>
                  <span>{activeTestimonial.role}</span>
                </div>
                <div
                  className="testimonial-rating"
                  aria-label={`${activeTestimonial.rating} out of 5 stars`}
                >
                  {Array.from(
                    { length: activeTestimonial.rating },
                    (_, ratingIndex) => (
                      <i
                        className="fa-solid fa-star"
                        key={ratingIndex}
                        aria-hidden="true"
                      />
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="visually-hidden" aria-live="polite">
        Testimonial {activeSlide + 1} of {content.items.length}
      </p>
    </section>
  );
}

export default Testimonials;
